<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
				<stop offset="0" stop-color="#19c6fc" />
				<stop offset="1" stop-color="#176dfa" />
			</linearGradient>
		</defs>
		<circle id="Ellipse_383" data-name="Ellipse 383" cx="10" cy="10" r="10" fill="url(#linear-gradient)" />
		<path
			id="Path_20403"
			data-name="Path 20403"
			d="M1078.071,384.4v-1.5a1.374,1.374,0,0,0-1.374-1.374h-1.5v0h0c0-.666.141-2.457-1.431-2.457s-1.318,1.7-1.318,2.457h0v0h-1.5a1.374,1.374,0,0,0-1.374,1.374v1.5h0a1.374,1.374,0,0,1,1.374,1.374h0a1.374,1.374,0,0,1-1.374,1.374h0v1.5a1.375,1.375,0,0,0,1.374,1.374h1.5a1.374,1.374,0,0,1,1.374-1.374h0a1.374,1.374,0,0,1,1.374,1.374h1.5a1.374,1.374,0,0,0,1.374-1.374v-1.709c.664,0,2.13.239,2.13-1.177S1078.83,384.4,1078.071,384.4Z"
			transform="translate(-1064.435 -375.039)"
			fill="#fff"
		/>
	</svg>
</template>

<script>
export default {
	name: 'PuzzleSVG',
};
</script>

<style scoped lang="scss"></style>
